import { render } from "./ResponsiveImg.vue?vue&type=template&id=1c31a7eb&scoped=true"
import script from "./ResponsiveImg.vue?vue&type=script&lang=js"
export * from "./ResponsiveImg.vue?vue&type=script&lang=js"

import "./ResponsiveImg.vue?vue&type=style&index=0&id=1c31a7eb&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/dindin.mombaby.kroutony.me/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c31a7eb"]])

export default __exports__